import { IFilter } from '@/shared';

export const applicantsQueryKeys = {
  all: ['applicants'] as const,
  sendCvList: (params: IFilter) =>
    [...applicantsQueryKeys.all, 'send-cv-list', params] as const,
} as const;
